import React from "react"
import Login from '../../forms/auth/Login'

const LoginModal= () => {

    return (
        <Login />
    )
}

export default LoginModal
